import { isValidClassicAddress } from 'ripple-address-codec'

export function isValidXRPLedgerAddress(address: string): boolean {
  return isValidClassicAddress(address)
}
